<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div class="field" [ngClass]="displayFieldCss('headOfficeAddressStreet')">
        <label>Company Address</label>
        <input
          formControlName="headOfficeAddressStreet"
          type="text"
          placeholder="Address"
        />
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressStreet')"
          errorMsg="Please company name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('companyContactEmail')">
        <label>Company Email</label>
        <input
          placeholder="Email"
          type="text"
          formControlName="companyContactEmail"
        />
        <div
          *ngIf="companyEmailLoading"
          class="ui fluid red basic label"
          style="margin: 0.3em 0"
        >
          <div class="ui tiny active inline loader"></div>
          checking email availability
        </div>
        <div *ngIf="companyEmailServerError" class="ui fluid red basic label">
          Oops! there seems to be a network problem,please try again
        </div>
        <div class="ui pointing red basic label" *ngIf="!companyEmailError">
          Email already exist, please enter again.
        </div>
        <div
          *ngIf="
            detailForm.controls['companyContactEmail'].dirty &&
            !detailForm.controls['companyContactEmail'].valid
          "
        >
          <div
            *ngIf="detailForm.controls['companyContactEmail'].hasError('email')"
            class="ui pointing red basic label"
          >
            Invalid email
          </div>
          <div
            *ngIf="
              detailForm.controls['companyContactEmail'].hasError('required')
            "
            class="ui pointing red basic label"
          >
            Please enter company email address
          </div>
        </div>
      </div>
      <div class="field" [ngClass]="displayFieldCss('alternativeMail')">
        <label>Company Alternative Email</label>
        <input
          formControlName="alternativeMail"
          type="text"
          placeholder="Company Alternative Email"
        />
        <app-field-error-display
          [displayError]="isFieldValid('alternativeMail')"
          errorMsg="Please enter alternative email"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('companyContactPhone1')">
        <label>Company Phone Number 1</label>
        <input
          formControlName="companyContactPhone1"
          type="text"
          placeholder="Company Contact Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('companyContactPhone1')"
          errorMsg="Please enter contact Phone Number"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('companyContactPhone2')">
        <label>Company Phone Number 2</label>
        <input
          formControlName="companyContactPhone2"
          type="text"
          placeholder="Company Contact Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('companyContactPhone2')"
          errorMsg="Please enter contact Phone Number"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('website')">
        <label>Website</label>
        <input formControlName="website" type="text" placeholder="Website" />
        <app-field-error-display
          [displayError]="isFieldValid('website')"
          errorMsg="Please enter website"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('countryOfRegistration')">
        <label>Country</label>
        <select
          class="ui fluid dropdown"
          placeholder="Select Country"
          formControlName="countryOfRegistration"
        >
          <option *ngFor="let opt of countries" [ngValue]="opt.countryCode">
            {{ opt.countryName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('countryOfRegistration')"
          errorMsg="Please select country"
        >
        </app-field-error-display>
      </div>

      <div
        class="field"
        *ngIf="foreign"
        [ngClass]="displayFieldCss('headOfficeAddressState')"
      >
        <label>State</label>
        <select
          class="ui fluid dropdown"
          placeholder="Select State"
          formControlName="headOfficeAddressState"
        >
          <option *ngFor="let opt of states" [ngValue]="opt.stateId">
            {{ opt.stateName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressState')"
          errorMsg="Please select state"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('headOfficeAddressCity')">
        <label>City</label>
        <input
          formControlName="headOfficeAddressCity"
          type="text"
          placeholder="City"
        />
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressCity')"
          errorMsg="Please enter city"
        >
        </app-field-error-display>
      </div>

      <div
        class="field"
        *ngIf="foreign"
        [ngClass]="displayFieldCss('headOfficeAddressStreet')"
      >
        <label>Street</label>
        <input
          formControlName="headOfficeAddressStreet"
          type="text"
          placeholder="Street"
        />
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressStreet')"
          errorMsg="Please enter address"
        >
        </app-field-error-display>
      </div>

      <div
        class="field"
        *ngIf="foreign"
        [ngClass]="displayFieldCss('headOfficeAddressZip')"
      >
        <label>Zip Code</label>
        <input
          formControlName="headOfficeAddressZip"
          type="text"
          placeholder="Zip Code"
        />
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressZip')"
          errorMsg="Please enter zip code"
        >
        </app-field-error-display>
      </div>

      <div
        class="field"
        *ngIf="foreign"
        [ngClass]="displayFieldCss('headOfficeAddressPmb')"
      >
        <label>PMB</label>
        <input
          formControlName="headOfficeAddressPmb"
          type="text"
          placeholder="headOfficeAddressPmb"
        />
        <app-field-error-display
          [displayError]="isFieldValid('headOfficeAddressPmb')"
          errorMsg="Please enter pmb"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="save()"
    autofocus
  >
    Done
  </button>
</div>
